import { useGetExerciseById } from '@entities/exercise/query/useGetExerciseById'
import { useParams } from 'react-router'
import { toast } from 'sonner'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'
import { ExerciseInfoPageSkeleton } from '@pages/exerciseInfo/ui/skeleton'
import React from 'react'
import { ExerciseDetailsScreen } from '@widgets/exercise/ExerciseDetailsView'
import './exercise-info.css'

export const ExerciseInfoPage = () => {
	const { exerciseId } = useParams<{ exerciseId: string }>()
	const nav = useIonRouter()

	const handleError = () => {
		toast.error('Ошибка при получении информации об этом упражнении')
		nav.push(ROUTES.overall.main)
	}

	const goBack = () => {
		if (nav.canGoBack()) {
			nav.goBack()
			return
		}
		nav.push(ROUTES.overall.trainingConstructor)
	}

	if (!exerciseId) {
		handleError()
		return
	}

	const { data: exercise, isLoading, isError } = useGetExerciseById(+exerciseId)

	if (isError || (!isLoading && !exercise)) {
		handleError()
		return
	}

	if (isLoading) {
		return <ExerciseInfoPageSkeleton goBackFunction={goBack} />
	}

	return <ExerciseDetailsScreen exercise={exercise} onBack={goBack} />
}
